import { render } from "./NavigationBarView.vue?vue&type=template&id=572ba56e&scoped=true"
import script from "./NavigationBarView.vue?vue&type=script&lang=js"
export * from "./NavigationBarView.vue?vue&type=script&lang=js"

import "./NavigationBarView.vue?vue&type=style&index=0&id=572ba56e&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572ba56e"]])

export default __exports__